import { NavLink, useLocation } from "react-router-dom";

/**
 * Footer — visible across all primary screens (hidden on auth/lesson screens).
 * Provides legal navigation: Privacy / Terms / About / IP Notice.
 */
const HIDDEN_ROUTES = ["/login", "/auth/callback"];

export default function Footer() {
  const loc = useLocation();
  if (HIDDEN_ROUTES.includes(loc.pathname)) return null;
  if (loc.pathname.startsWith("/lesson/")) return null;

  return (
    <footer className="app-footer" data-testid="app-footer">
      <div className="app-footer-inner">
        <nav className="app-footer-links" aria-label="روابط قانونيّة">
          <NavLink to="/about" data-testid="footer-about">
            من نحن
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/methodology" data-testid="footer-methodology">
            المنهج
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/pricing" data-testid="footer-pricing">
            الأسعار
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/partnerships" data-testid="footer-partnerships">
            شراكات
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/contact" data-testid="footer-contact">
            تواصل
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/privacy" data-testid="footer-privacy">
            الخصوصيّة
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/terms" data-testid="footer-terms">
            الشروط
          </NavLink>
          <span className="dot" aria-hidden>·</span>
          <NavLink to="/ip-notice" data-testid="footer-ip">
            الملكيّة الفكريّة
          </NavLink>
        </nav>
        <div className="app-footer-copy" data-testid="footer-copy">
          © {new Date().getFullYear()} بَلاغة — جميع الحقوق محفوظة.
        </div>
      </div>
    </footer>
  );
}
